import apiClient from "./apiClient";

const refClient = apiClient('');

const referralApi = {
    // Получить реф-ссылку (общую или для промо).
    // referralType нужен, когда роль сама тип не определяет: создатель промо,
    // участвующий в своём же промо, без него получит ссылку промоутера.
    async getReferralLink(promoId = null, referralType = null) {
        const params = {};
        if (promoId) params.promoId = promoId;
        if (referralType) params.referralType = referralType;
        return (await refClient.get('/referral/my', { params })).data;
    },

    // Общая статистика рефералов пользователя
    async getMyStats() {
        return (await refClient.get('/referral/my/stats')).data;
    },

    // Список приглашённых пользователей
    async getMyReferrals() {
        return (await refClient.get('/referral/my/list')).data;
    },

    // Статистика по конкретному промо
    async getPromoStats(promoId) {
        return (await refClient.get(`/referral/my/promo/${promoId}/stats`)).data;
    },

    // Проверить можно ли сделать второй claim
    async canClaimSecond(promoId) {
        return (await refClient.get(`/referral/can-claim-second/${promoId}`)).data;
    },

    async checkInviteRequirement(promoId) {
        return (await refClient.get(`/referral/check-invite-requirement/${promoId}`)).data;
    },
};

export default referralApi;
